import './src/styles/variables.module.css';
import './src/styles/typography.module.css';
import './src/styles/global.css';
import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import Page from './src/components/layout/Page';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return <Page element={element} props={props} />;
};
